<wr-base-dialog [submitResponse]="submitAction"
                [disableSubmit]="!form?.form?.valid"
                header="Benutzerdefinierte Gruppe erstellen"
                status="primary">
  <wr-custom-field-collection-form [folderPath]="folderPath" [customFieldCollection]="null"></wr-custom-field-collection-form>
</wr-base-dialog>
